export default __webpack_public_path__ + "static/media/mhostel.347f5620.jpg";